import type { ReactNode } from 'react';
import { COLUMNS } from '@bingo/shared';

/**
 * Card centrado das telas de entrada.
 *
 * Usa os tokens do palco (stage.css) para o produto ser reconhecível desde a
 * primeira tela: mesmo fundo, mesma tipografia de display, mesmo dourado. As
 * cinco cores B-I-N-G-O aparecem como fio no topo — detalhe pequeno, mas é o
 * que faz a tela de login parecer deste produto e não de qualquer um.
 */
export function AuthCard({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main className="auth">
      <section className="auth-card">
        <div className="auth-stripe" aria-hidden="true">
          {COLUMNS.map((column) => (
            <i key={column.letter} style={{ background: column.color }} />
          ))}
        </div>

        <header className="auth-head">
          <p className="auth-brand" aria-hidden="true">
            {COLUMNS.map((column) => (
              <span key={column.letter} style={{ color: column.color }}>
                {column.letter}
              </span>
            ))}
          </p>
          <h1>{title}</h1>
          {subtitle ? <p className="auth-sub">{subtitle}</p> : null}
        </header>

        {children}

        {footer ? <footer className="auth-foot">{footer}</footer> : null}
      </section>
    </main>
  );
}
